const Back = () => {

    const backButton = document.querySelector('.single-post__image-back');
    
    if (backButton) {
        backButton.addEventListener('click', function(event) {
            event.preventDefault(); // Zapobiega domyślnemu zachowaniu linku, jeśli to jest link
            window.history.back();
        });
    }

}

export default Back;